function csvEscape(value) {
  const text = String(value ?? "");

  return `"${text.replaceAll(
    '"',
    '""'
  )}"`;
}


function safeBaseName(filename) {
  return filename
    .replace(/\.[^/.]+$/, "")
    .replace(
      /[^a-zA-Z0-9_-]+/g,
      "_"
    );
}


export function downloadText(
  filename,
  text
) {
  const blob = new Blob(
    ["\uFEFF", text],
    {
      type:
        "text/csv;charset=utf-8",
    }
  );

  const url = URL.createObjectURL(
    blob
  );

  const link = document.createElement(
    "a"
  );

  link.href = url;
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  link.remove();

  URL.revokeObjectURL(url);
}


export function buildIndividualCsv(
  sheet
) {
  const header = [
    "Sheet",
    "Exam Questions",
    "Question",
    "Detected Answer",
    "Correct Answer",
    "Status",
    "Score A",
    "Score B",
    "Score C",
    "Score D",
  ];

  const rows = sheet.questions.map(
    (question) => [
      sheet.filename,
      sheet.summary.total,
      question.question,
      question.detectedAnswer,
      question.correctAnswer,
      question.status,
      question.scoreA,
      question.scoreB,
      question.scoreC,
      question.scoreD,
    ]
  );

  return [header, ...rows]
    .map(
      (row) =>
        row.map(csvEscape).join(",")
    )
    .join("\n");
}


export function buildCombinedCsv(
  results
) {
  const successful = results.filter(
    (sheet) => sheet.success
  );

  const header = [
    "Sheet",
    "Exam Questions",
    "Question",
    "Detected Answer",
    "Correct Answer",
    "Status",
    "Score A",
    "Score B",
    "Score C",
    "Score D",
  ];

  const rows = successful.flatMap(
    (sheet) =>
      sheet.questions.map(
        (question) => [
          sheet.filename,
          sheet.summary.total,
          question.question,
          question.detectedAnswer,
          question.correctAnswer,
          question.status,
          question.scoreA,
          question.scoreB,
          question.scoreC,
          question.scoreD,
        ]
      )
  );

  return [header, ...rows]
    .map(
      (row) =>
        row.map(csvEscape).join(",")
    )
    .join("\n");
}


export function buildSummaryCsv(
  results
) {
  const header = [
    "Sheet",
    "Exam Questions",
    "Processing Status",
    "Correct",
    "Wrong",
    "Blank",
    "Multiple",
    "Percentage",
    "Threshold",
    "Error",
  ];

  const rows = results.map(
    (sheet) => {
      if (!sheet.success) {
        return [
          sheet.filename,
          "",
          "failed",
          "",
          "",
          "",
          "",
          "",
          "",
          sheet.error,
        ];
      }

      return [
        sheet.filename,
        sheet.summary.total,
        "success",
        sheet.summary.correct,
        sheet.summary.wrong,
        sheet.summary.blank,
        sheet.summary.multiple,
        sheet.summary.percentage,
        sheet.summary.threshold,
        "",
      ];
    }
  );

  return [header, ...rows]
    .map(
      (row) =>
        row.map(csvEscape).join(",")
    )
    .join("\n");
}


export function individualCsvName(
  sheet
) {
  return (
    safeBaseName(sheet.filename)
    + `_${sheet.summary.total}`
    + "_question_result.csv"
  );
}
